'use strict';

import React from "react";

import Lists from "@uw-it-sis/lib-react/lib/Lists";
import {handleInputMaxLength, handleInputNumbersOnly} from "@uw-it-sis/lib-react/lib/ValidationUtils";

import registrationDetailsStore from "../registration/RegistrationDetailsStore";
import planItemModalStore from "../registration/PlanItemModalStore";
import errorMessageFactory from "../registration/ErrorMessageFactory";
import planItemStore from "@uw-it-sis/lib-react-myplan/lib/PlanItemStore";

const PlanItemFunctionConstants = {};

/**
 * Updates the store state data based on changes to the entry codes or course selection
 * @param e The onChange js event
 */
PlanItemFunctionConstants.onFormChange = (e) => {
    let value, property, identifier;
    if (e.target.type === "checkbox") {
        // this is for updating a course selector
        property = 'sendToRegistration';
        identifier = e.target.value;
        value = e.target.checked;
    } else {
        // this is for updating an entry code
        property = 'entryCode';
        identifier = e.target.dataset.activityId;
        value = e.target.value;
    }

    registrationDetailsStore.updateRegistrationItems(property, identifier, value);
};

/**
 * Restricts input on the entry code field to the maxlength value on the input.
 * @param e The onInput js event
 * @return true if the value length is less then or equal to maxlength, else ignore any attempt to input more then the maxlength
 */
PlanItemFunctionConstants.onEntryCodeInput = handleInputMaxLength;

/**
 * Restricts input on the entry code field to just digits and select/copy/cut/paste/tab/esc actions
 * @param e The js event from keydown
 * @return true if key is allowed, if not, then preventDefault
 */
PlanItemFunctionConstants.onEntryCodeKeyDown = handleInputNumbersOnly;

PlanItemFunctionConstants.onDeleteSection = (planItem, analyticsData) => {
    planItemModalStore.openModal('delete', section, analyticsData);
};

PlanItemFunctionConstants.onDeleteCourse = (course, analyticsData) => {
    planItemModalStore.openModal('delete', course, analyticsData);
};

PlanItemFunctionConstants.onMoveCourse = (course, analyticsData) => {
    planItemModalStore.openModal('move', course, analyticsData);
};

PlanItemFunctionConstants.onAddEditSections = (course, analyticsData) => {
    // ['context=RegView-modal']
    planItemModalStore.openModal('update', course, analyticsData);
};

PlanItemFunctionConstants.onChangeType = (planItemId, type, planItemTitle, note, placeHolderText) => {
    planItemStore.changeType(planItemId, type, planItemTitle, note, placeHolderText);
};

/**
 *  Creates the issue message component
 * @param actionCode
 * @param course
 * @param analyticsData
 * @returns {*}
 */
PlanItemFunctionConstants.makeMessageComponent = (actionCode, course, analyticsData) => {
    return (
        <div key={actionCode}>
            <Lists data={course.validationIssues[actionCode]} unstyled />
            {errorMessageFactory.generateLink(actionCode, course, analyticsData)}
        </div>
    );
};

export default PlanItemFunctionConstants;